import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { ILead, IDropdown, IContact } from "../../models/BaseModel";
import { useForm } from 'react-hook-form';
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useEffect, useState } from "react";
import { Fetch } from "../../shared/Fetch";
import { JVDropdown } from "../../shared/JVDropdown";
import { JVDropdownInput } from "../../shared/JVDropdownInput";
import { JVInput } from "../../shared/JVInput";
import { Tag } from "primereact/tag";


const schema = yup.object({
    assigned_To: yup.number().nullable(),
});

interface Iprops {
    singleData: ILead,
    open: boolean,
    hideDialog: () => void,
    toast: any,
    reloadData: () => void,
    hasPermission: (pageName: string, featureName?: string) => boolean
    contacts: IContact[],

}

export const BulkReAssignLead = (props: Iprops) => {
    const [contacts, setContacts] = useState<IDropdown[]>();
    const [sources, setSources] = useState<IDropdown[]>();
    const [status, setStatus] = useState<IDropdown[]>();
    const [users, setUsers] = useState<IDropdown[]>();
    const [submitting, setSubmitting] = useState(false);

    const { control, handleSubmit, formState: { errors }, reset, watch, setValue } = useForm<ILead>({
        resolver: yupResolver(schema),
        defaultValues: props.singleData,
        shouldFocusError: false,
    });

    useEffect(() => {
        loadUsers();
    }, []);


    // useEffect(() => {
    //     console.log(props.singleData)
    //     if (props.singleData.id) props.singleData.contact = { id: props.singleData.id || 0, contact_Person_Name: props.singleData.contact_Person_Name + ' | ' + props.singleData.contact_Person_Number };

    //     reset(props.singleData);
    // }, [props.singleData]);

    useEffect(() => {
        console.log(props.singleData);

        if (props.singleData.id) {
            const updatedData = {
                ...props.singleData,
                contact: {
                    id: props.singleData.id || 0,
                    contact_Person_Name:
                        props.singleData.contact_Person_Name + ' | ' + props.singleData.contact_Person_Number
                },
                assigned_To: props.singleData.onBehalfUserID
            };

            reset(updatedData);
        } else {
            reset(props.singleData);
        }
    }, [props.singleData, reset]);



    const loadUsers = async () => {
        const response = await Fetch("user/dropdown", "GET", null, null, null);
        if (response) {
            setUsers(await response.json());
        }
    }

    const loadContacts = async (text: string | null) => {
        const query = text ? `text=${text}` : '';
        const response = await Fetch("contact_Person/dropdown", "GET", null, query, null);
        if (response) {
            setContacts(await response.json());
        }
    }
    const completeMethodContacts = (event: { query: string }) => {
        loadContacts(event.query);
    }

    console.log(props.contacts)

    const saveToDB = async (data: any) => {
        setSubmitting(true);
        const body = {
            leadIds: props.contacts.map(c => c.id ?? 0),
            assignedTo: data?.assigned_To
        };
        const response = await Fetch(`leads/reassign`, "PUT", body, null, props.toast);

        if (response) {
            onHide();
            props.toast.current.show({
                severity: "success",
                detail: "Leads reassigned successfully",
                life: 3000,
            });
            props.reloadData();
        }

        setSubmitting(false);
    };


    const onHide = () => {
        props.hideDialog();
        reset({});
    }

    function onSubmit(data: ILead) {
        saveToDB(data);
    }

    return (
        <Dialog visible={props.open} style={{ width: '400px' }} header="Generate Lead" modal className="p-fluid" onHide={onHide}>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
                {/* <div className="flex flex-wrap gap-2 mb-3 ml-3">
                    {props.contacts.map((cont, index) => {
                        return <div key={index} className="flex items-center">
                            <Tag className="mr-2 py-2 px-3" severity="warning" icon="pi pi-user" value={cont.contact_Person_Name}></Tag>
                        </div>
                    })}
                </div> */}
                {/* <JVDropdownInput column={1} disabled required completeMethod={completeMethodContacts} label="Contact" control={control} name="contact" error={errors.contact?.id?.message} options={contacts} optionLabel="contact_Person_Name" placeholder="Search Contact" /> */}
                <JVDropdown required column={1} label="Assign To" control={control} options={users} optionLabel="name" optionValue="id" name="assigned_To" placeholder="Select" error={errors.assigned_To?.message} />

                {/* <JVDropdown  disabled required label="Status" control={control} options={status} optionLabel="status_Name" optionValue="id" name="status_ID" placeholder="Select Status" error={errors.status_ID?.message} /> */}
                <div className="col-12 md:col-12 flex gap-4 justify-content-end">
                    <Button style={{ width: '100px' }} loading={submitting} label="SAVE" type="submit" className="p-button-rounded"></Button>
                    <Button style={{ width: '100px' }} label="CLOSE" onClick={onHide} type="button" className="p-button-rounded p-button-outlined surface-200"></Button>
                </div>
            </form>
        </Dialog>
    );
}